<style scoped lang="less">
    .container {
        width: 100%;
        height: 0%;
        margin: 0 auto;
        color: #0e0d0d;
    }

    .body {
        width: 100%;
        height: 0%;
        display:flex;
        justify-content: center;
        color: rgb(0, 0, 0);
        /* background-color: #d9d9d9; */
        font-size: large;
    }



    
</style>


<template>
    <div class="container">
        
        <div class="body" style="min-width: 100%; min-height: 100%">
          
        </div>
        
    </div>
</template>




<script>
    export default {
        
        components: {},

        data() {
            return {
            }
        },

        mounted() {
            
     
        },


        methods: {

            

        },
    };
</script>

